import CryptoJS from 'crypto-js';

const getTimestamp = (text) => {
  const _0x327e01 = _0x2e0a;
  function _0x1d3d() {
    const _0xa15d4b = [
      'toString',
      '1686AIfNln',
      'SHA256',
      '11820kdwKzb',
      '4910112pGLvGf',
      '1310938LvTcEl',
      'getUTCMonth',
      'getUTCHours',
      '3897215YPXyAv',
      '1424655BSGKvo',
      '1034839jmFrDS',
      '36742056yZhhsg',
      'padStart',
      'getUTCFullYear',
      'getUTCDate',
    ];
    _0x1d3d = function () {
      return _0xa15d4b;
    };
    return _0x1d3d();
  }
  (function (_0x3eb470, _0x3fbc63) {
    const _0x2d5a47 = _0x2e0a,
      _0x37c4cf = _0x3eb470();
    while (!![]) {
      try {
        const _0x47d379 =
          -parseInt(_0x2d5a47(0xb6)) / 0x1 +
          -parseInt(_0x2d5a47(0xb1)) / 0x2 +
          parseInt(_0x2d5a47(0xb5)) / 0x3 +
          -parseInt(_0x2d5a47(0xb0)) / 0x4 +
          (parseInt(_0x2d5a47(0xbe)) / 0x5) * (-parseInt(_0x2d5a47(0xbc)) / 0x6) +
          -parseInt(_0x2d5a47(0xb4)) / 0x7 +
          parseInt(_0x2d5a47(0xb7)) / 0x8;
        if (_0x47d379 === _0x3fbc63) break;
        else _0x37c4cf['push'](_0x37c4cf['shift']());
      } catch (_0x543e3b) {
        _0x37c4cf['push'](_0x37c4cf['shift']());
      }
    }
  })(_0x1d3d, 0xe2c09);
  function _0x2e0a(_0x1d2f1c, _0x5e7602) {
    const _0x1d3d9b = _0x1d3d();
    return (
      (_0x2e0a = function (_0x2e0ade, _0x1ecb36) {
        _0x2e0ade = _0x2e0ade - 0xb0;
        let _0x4f654a = _0x1d3d9b[_0x2e0ade];
        return _0x4f654a;
      }),
      _0x2e0a(_0x1d2f1c, _0x5e7602)
    );
  }
  function ch(_0x174d83) {
    const _0x416a46 = _0x2e0a;
    return CryptoJS[_0x416a46(0xbd)](_0x174d83)[_0x416a46(0xbb)]();
  }
  const now = new Date(),
    year = now[_0x327e01(0xb9)](),
    month = String(now[_0x327e01(0xb2)]() + 0x1)['padStart'](0x2, '0'),
    day = String(now[_0x327e01(0xba)]())[_0x327e01(0xb8)](0x2, '0'),
    hours = String(now[_0x327e01(0xb3)]())['padStart'](0x2, '0'),
    date = '' + year + month + day + hours;
  text += ch(date);
  return CryptoJS[_0x327e01(0xbd)](ch(text))[_0x327e01(0xbb)]();
};

export default getTimestamp;
